import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {
  button,
  buttonRed,
  buttonRedInverted,
  buttonGray,
  buttonGrayInverted,
} from './scss/Button.module.scss';

const Button = ({ children, tag, buttonColor, ...props }) => {
  const Tag = tag || 'button';
  const buttonProps = {
    ...(Tag === 'button' && { type: 'button' }),
  };
  const buttonColorClassName = {
    red: buttonRed,
    redInverted: buttonRedInverted,
    gray: buttonGray,
    grayInverted: buttonGrayInverted,
  }[buttonColor];
  const buttonClassNames = classNames(button, buttonColorClassName);
  return (
    <Tag {...props} {...buttonProps} className={buttonClassNames}>
      {children}
    </Tag>
  );
};

Button.propTypes = {
  onClick: PropTypes.func,
  tag: PropTypes.object,
  children: PropTypes.node.isRequired,
  buttonColor: PropTypes.oneOf(['red', 'redInverted', 'gray', 'grayInverted']),
};

Button.defaultProps = {
  tag: null,
  buttonColor: null,
  onClick: () => {},
};

export default Button;
